"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[384],{

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BookACall = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "Open a new tab to book a 15 minute call",
        className: "text-md   h-full w-full font-bold underline  transition-colors hover:text-brand-pink hover:no-underline  " + props.className,
        href: "https://calendly.com/scrumify-at/15min",
        children: "Book a 15 min call"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BookACall);


/***/ })

}]);